(() => {
  const MANAGER_KEY = '__customDisableVariantMediaSyncManager';
  const PRODUCT_INFO_SELECTOR = 'product-info[data-custom-product-ui-section]';

  function findProductInfoElements(scope = document) {
    const elements = scope.matches?.(PRODUCT_INFO_SELECTOR)
      ? [scope]
      : Array.from(scope.querySelectorAll?.(PRODUCT_INFO_SELECTOR) || []);

    return elements;
  }

  function disableVariantMediaSync(scope = document) {
    findProductInfoElements(scope).forEach((productInfo) => {
      if (productInfo.dataset.customVariantMediaSyncDisabled === 'true') return;

      productInfo.dataset.customVariantMediaSyncDisabled = 'true';
      productInfo.updateMedia = () => {};
    });
  }

  function start() {
    customElements.whenDefined('product-info').then(() => {
      disableVariantMediaSync(document);

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              disableVariantMediaSync(node);
            }
          });
        });
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });

      window[MANAGER_KEY] = {
        apply: disableVariantMediaSync,
        observer,
      };
    });
  }

  if (window[MANAGER_KEY]) {
    window[MANAGER_KEY].apply(document);
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    customElements.whenDefined('product-info').then(() => disableVariantMediaSync(event.target));
  });
})();
